import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const mySwiper = document.getElementsByClassName('mySwiper');

if(mySwiper){
    new Swiper(".mySwiper", {
        modules: [Navigation, Pagination],
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="mx-1 ' + className + '">' + '</span>';
            },
        },

        breakpoints: {
            768: {
                slidesPerView: 2
            }
        }
    });
}